import { Bell, Search, HelpCircle, Menu } from 'lucide-react'
import { useState } from 'react'

export default function Header({ sidebarOpen = true, onToggleSidebar }) {
  const [showNotifications, setShowNotifications] = useState(false)
  const [showSearch, setShowSearch] = useState(false)

  const notifications = [
    { id: 1, title: 'New ticket assigned', description: 'TKT-001 assigned to you', time: '5 mins ago' },
    { id: 2, title: 'Course completed', description: 'John Smith completed Python course', time: '2 hours ago' },
    { id: 3, title: 'Escalation alert', description: 'Angry customer needs attention', time: '30 mins ago' },
  ]

  return (
    <header className="bg-gradient-to-r from-slate-800 to-slate-900 border-b border-blue-500/30 px-8 py-4 flex items-center justify-between shadow-lg">
      {/* Sidebar Toggle Button */}
      {onToggleSidebar && (
        <button
          onClick={onToggleSidebar}
          className="mr-4 p-2 hover:bg-slate-700 rounded-lg transition-colors text-blue-400 hover:text-blue-300"
          title={sidebarOpen ? 'Close Sidebar' : 'Open Sidebar'}
        >
          <Menu size={24} />
        </button>
      )}

      <div className="flex-1">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-400" size={20} />
          <input
            type="text"
            placeholder="Search tickets, knowledge base..."
            className="bg-slate-700/50 border border-blue-500/30 pl-10 w-64 px-4 py-2.5 rounded-lg text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
            onFocus={() => setShowSearch(true)}
            onBlur={() => setShowSearch(false)}
          />
        </div>
      </div>

      <div className="flex items-center space-x-6">
        {/* Help */}
        <button className="text-blue-400 hover:text-blue-300 transition-colors" title="Help">
          <HelpCircle size={24} />
        </button>

        {/* Notifications */}
        <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative text-blue-400 hover:text-blue-300 transition-colors"
            title="Notifications"
          >
            <Bell size={24} />
            <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse shadow-lg shadow-red-500/50"></span>
          </button>

          {/* Notification Dropdown */}
          {showNotifications && (
            <div className="absolute right-0 mt-2 w-80 bg-gradient-to-b from-slate-800 to-slate-900 rounded-lg shadow-2xl border border-blue-500/30 z-50">
              <div className="p-4 border-b border-blue-500/20">
                <h3 className="font-bold text-white">Notifications</h3>
              </div>
              <div className="max-h-96 overflow-y-auto">
                {notifications.map((notif) => (
                  <div key={notif.id} className="p-4 border-b border-blue-500/10 hover:bg-blue-600/20 cursor-pointer transition-all last:border-b-0">
                    <p className="font-semibold text-white text-sm">{notif.title}</p>
                    <p className="text-blue-300 text-xs mt-1">{notif.description}</p>
                    <p className="text-blue-400/60 text-xs mt-2">{notif.time}</p>
                  </div>
                ))}
              </div>
              <div className="p-3 border-t border-blue-500/20 text-center">
                <button className="text-blue-400 hover:text-blue-300 text-sm font-semibold transition-colors">View all</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
